import { useContext } from 'react';
import { StatusBarContext } from '../components/Layout';

// Custom hook to get the status bar height
export const useStatusBarHeight = () => {
  const context = useContext(StatusBarContext);
  
  // If not within Layout context, return 0
  if (!context) {
    return 0;
  }
  
  return context.height;
};

export default useStatusBarHeight;